<template>
  <v-app>
    <v-card width="full-width" style="max-height: 460px" elevation="0">
      <v-container fluid>
        <v-row>
          <v-icon size="25" class="ml-5">dashboard</v-icon>
          <v-breadcrumbs :items="itemsBreadcrumbs">
            <v-breadcrumbs-item
              slot="item"
              slot-scope="{ item }"
              exact
              @click="breadcrumbsMethods(item)"
              :disabled="tableLoading==true"
              :to="item.to"
              class="font-weight-bold pl-1"
              style="font-size:20px"
            >{{ item.namefolder }}</v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-row>
        <v-row>
          <v-col cols="12" sm="8"></v-col>
          <v-col class="text-center" cols="12" sm="4">
            <div>
              <v-btn class="ma-2 primary" @click="addFolder()">
                <v-icon left>add</v-icon>Add folder
              </v-btn>
              <v-btn class="primary" @click="addcontant()">
                <v-icon left>add</v-icon>Add Files
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-dialog v-model="addFolderStatus" width="500px">
      <v-card>
        <v-card-title class="secondary">
          <span class="subtitle white--text">Add Folder to:{{ nameOfFolder.namefolder }}</span>
          <v-spacer></v-spacer>
          <v-icon @click="addFolderClose()" class="white--text">mdi-close</v-icon>
        </v-card-title>
        <v-container>
          <v-card-text>
            <v-row>
              <v-text-field
                label="Folder Name"
                v-model="addFolderName"
                :rules="[rules.specialCharecter]"
                :maxlength="max_num"
                placeholder="Enter Folder Name"
                outlined
                dense
              ></v-text-field>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="primary" :loading="loading3" @click="addOfFolderMethod(nameOfFolder)">Add</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addContentStatus" width="500px">
      <v-card>
        <v-card-title class="secondary">
          <span class="subtitle white--text">Add File to:{{ nameOfFolder.namefolder }}</span>
          <v-spacer></v-spacer>
          <v-icon @click="addContentClose()" class="white--text">mdi-close</v-icon>
        </v-card-title>
        <v-container>
          <v-card-text>
            <v-row>
              <v-file-input v-model="addContentFolder" label="File input" outlined dense></v-file-input>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="primary"
              :loading="loading2"
              @click="addContantMethod(nameOfFolder,addContentFolder)"
            >Add</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <v-data-table
      :headers="headers"
      :items="arrayOfFolder"
      :loading="tableLoading"
      disabled
      class="elevation-10 caption"
    >
      <template v-slot:item.namefolder="{ item }">
        <v-icon small class="mr-2" v-if="item.fileType!='File folder'">cloud_download</v-icon>
        <v-icon small class="mr-2" v-if="item.fileType=='File folder'">folder</v-icon>
        <span
          @click="handleClick(item)"
          :disabled="tableLoading==true"
          class="caption"
        >{{ item.namefolder }}</span>
      </template>
      <template v-slot:item.Action="{ item }">
        <v-btn color="secondary" text @click="deletedialogmethod(item)">
          <v-icon medium>delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog v-model="deletedialog" max-width="400">
      <v-card>
        <v-card-title class="secondary" height="20px">
          <span class="body-2 white--text">Delete</span>
          <v-spacer></v-spacer>
          <v-icon @click="deletedialog = false" class="white--text">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="text-center mt-3">Are you sure you want to delete {{ deleteFolderName}}</v-card-text>
        <v-card-actions>
          <v-btn
            class="primary white--text mr-5"
            text
            @click="deletedialog = false"
            id="Nobutton"
          >No</v-btn>
          <v-btn
            class="secondary white--text"
            :loading="deleteLoading"
            :disable="deleteLoading"
            text
            @click="deleteItem(deleteItemsValue)"
          >Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="tableLoading" width="300" persistent>
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="alertPositive"
      color="secondary"
      :timeout="timeout"
      bottom="bottom"
    >{{ text }}</v-snackbar>
    <v-snackbar
      v-model="alertNegetive"
      color="primary"
      :timeout="timeout"
      bottom="bottom"
    >{{ text }}</v-snackbar>
  </v-app>
</template>
<script>
var aws = require("aws-sdk");
export default {
  data() {
    return {
      deleteLoading: false,
      deleteItemsValue: [],
      deleteFolderName: "",
      deletedialog: "",
      text: "",
      alertNegetive: false,
      alertPositive: false,
      rules: {
        specialCharecter: value => {
          const pattern = /[^-\s][A-Za-z0-9 ]+$/;
          return pattern.test(value) || "Special Characters Not Allowed";
        }
      },
      timeout: 2000,
      msg: "Hello",
      dialog: false,
      tableLoading: false,
      arrayItemprefix: [],
      addContentFolder: [],
      itemsBreadcrumbs: [],
      arrayOfFolder: [],
      nameOfFolder: [],
      resourceFolder: {
        Prefix: this.$store.getters.get_orgId + "/" + "Resource/",
        namefolder: "Resource"
      },
      addContentStatus: false,
      addFolderStatus: false,
      loading3: false,
      loading2: false,
      addFolderName: "",
      max_num: 25,
      selectionType: "leaf",
      selection: [],
      headers: [
        {
          text: "Name",
          align: "start",
          class: "grey lighten-2",
          value: "namefolder"
        },
        {
          text: "Date Modified",
          value: "LastModified",
          class: "grey lighten-2"
        },
        { text: "Type", value: "fileType", class: "grey lighten-2" },
        { text: "Size", value: "Size", class: "grey lighten-2" },
        {
          text: "Action",
          value: "Action",
          sortable: false,
          class: "grey lighten-2"
        }
      ]
    };
  },
  created() {
    this.addResource(this.resourceFolder, "1");
    this.itemsBreadcrumbs;
  },
  methods: {
    deletedialogmethod(itemsValue) {
      //  console.log(itemsValue);
      this.deleteItemsValue = itemsValue;
      this.deleteFolderName = itemsValue.namefolder;
      this.deletedialog = true;
    },
    deleteItem(items) {
      //  console.log(items);
      this.deleteLoading = true;
      var s3Client = new aws.S3({
        region: "us-east-1",
        accessKeyId: "AKIAWBVZKTFUN6FHJNUI",
        secretAccessKey: "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"
      });
      var params = {
        Bucket: "adjustermate-stage",
        Key: items.Prefix
      };
      var self = this;
      s3Client.deleteObject(params, function(err, data) {
        if (err) console.log(err, err.stack);
        // an error occurred
        else {
          console.log(data);
          var index = self.itemsBreadcrumbs.length - 1;
          self.addResource(self.itemsBreadcrumbs[index], "0");
          self.deleteItemsValue = [];

          self.deleteLoading = false;
          self.deletedialog = false;
          self.text = "Deleted Successfully";
          self.alertPositive = true;
        } // successful response
      });
    },
    addContentClose() {
      this.addContentStatus = false;
      this.addContentFolder = [];
    },

    addFolderClose() {
      this.addFolderStatus = false;
      this.addFolderName = null;
    },
    breadcrumbsMethods(valueBreadcrumbs) {
      const index = this.itemsBreadcrumbs.indexOf(valueBreadcrumbs);

      this.itemsBreadcrumbs.splice(index + 1, this.itemsBreadcrumbs.length);

      // this.itemsBreadcrumbs = [];
      this.addResource(valueBreadcrumbs, "0");
    },
    handleClick(value) {
      //   console.log(value);
      if (value.fileType == "File folder") {
        this.nameOfFolder = value;

        this.addResource(value, "1");
      } else {
        var url = value.urlFile;
        window.open(url, "Download");
      }
    },
    addResource(dataValueList, type) {
      this.tableLoading = true;
      //console.log("bbbbbbbbbb", this.dialog);
      this.nameOfFolder = dataValueList;

      var arrayOfCommonName = [];
      var s3Client = new aws.S3({
        region: "us-east-1",
        accessKeyId: "AKIAWBVZKTFUN6FHJNUI",
        secretAccessKey: "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"
      });
      let params = {
        Bucket: "adjustermate-stage",
        Delimiter: "/",
        Prefix: dataValueList.Prefix
        // Prefix: response.key //"MOBIL80/USER/f931447f-9424-4d5c-a29a-18299b997428/"
      };
      var self = this;
      s3Client.listObjectsV2(params, function(err, dataValue) {
        if (err) console.log(err, err.stack);
        // an error occurred
        else {
          if (type == "1") {
            self.itemsBreadcrumbs.push({
              Prefix: dataValueList.Prefix,
              namefolder: dataValueList.namefolder
            });
          }

          dataValue.CommonPrefixes.forEach(function(element) {
            element.namefolder = element.Prefix.replace(
              dataValueList.Prefix,
              ""
            );
          });
          dataValue.CommonPrefixes.forEach(function(element) {
            element.namefolder = element.namefolder.replace("/", "");
            element.fileType = "File folder";
            element.LastModified = "-";
            element.Size = "-";
          });
          dataValue.CommonPrefixes.forEach(function(element) {
            element.namefolder = element.namefolder.replace("/", "");
            arrayOfCommonName.push(element);
          });
          dataValue.Contents.forEach(function(element) {
            if (element.Key != dataValueList.Prefix) {
              element.namefolder = element.Key.replace(
                dataValueList.Prefix,
                ""
              );
              element.Prefix = element.Key;
              element.Size = (element.Size / (1024 * 1024)).toFixed(2) + " MB";
              element.fileType = element.namefolder.split(".")[1].toUpperCase();
              element.urlFile =
                "https://adjustermate-stage.s3.amazonaws.com/" + element.Key;
              element.LastModified = new Date(
                element.LastModified
              ).toLocaleString();
              arrayOfCommonName.push(element);
            }
          });

          // dataValue.Contents.splice(0, 1);
          // dataValue.Contents.forEach(function(element) {
          //   element.namefolder = element.Key.replace(dataValue.Prefix, "");
          //   element.Prefix = element.Key;
          //   element.Size = (element.Size / (1024 * 1024)).toFixed(2) + " MB";
          //   element.fileType = element.namefolder.split(".")[1].toUpperCase();
          //   element.urlFile =
          //     "https://adjustermate-stage.s3.amazonaws.com/" + element.Key;
          //   element.LastModified = new Date(
          //     element.LastModified
          //   ).toLocaleString();
          //   arrayOfCommonName.push(element);
          // });

          // console.log("mmmmmmmmmmmmmmmmmmmmmmmm", arrayOfCommonName);
          self.arrayOfFolder = arrayOfCommonName;
          self.tableLoading = false;
          self.$forceUpdate();
          // console.log("dataValue", self.arrayOfFolder);
        }
      });
    },
    getItemArray() {
      this.items.push({
        id: 1,
        name: "Resource",
        path: "Resource"
      });
      //   console.log("mmmmmmmmmmmmmmmmmmm", this.items);
    },
    validateForContent(fileName) {
      var fileNametest = fileName.replace(/\s+/g, "_");
      var valid = false;
      if (this.arrayOfFolder.length == 0) {
        valid = true;
      } else {
        for (let i = 0; i < this.arrayOfFolder.length; i++) {
          if (fileNametest == this.arrayOfFolder[i].namefolder) {
            // console.log(this.deployedFormTemepletes[i].form_name);
            valid = false;
            break;
          } else {
            valid = true;
          }
        }
      }

      //  alert(valid);
      return valid;
    },
    addContantMethod(arrayItem, fileupload) {
      //  console.log(fileupload);
      if (fileupload.length != 0) {
        this.loading2 = true;

        // console.log(arrayItem);
        this.arrayItemprefix = arrayItem;
        const files = fileupload;
        fileupload = files.name;

        if (this.validateForContent(files.name) == false) {
          this.text = "File Already Exist";
          this.alertNegetive = true;
          this.loading2 = false;
        } else {
          if (fileupload.lastIndexOf(".") <= 0) {
            return;
          }
          fileupload = [];
          const fr = new FileReader();
          fr.readAsDataURL(files);
          fr.addEventListener("load", async () => {
            //   console.log(fr.result);
            var imageUrl = [];
            imageUrl = fr.result.replace("data:" + files.type + ";base64,", "");
            //  console.log(imageUrl);
            var s3Client = new aws.S3({
              region: "us-east-1",
              accessKeyId: "AKIAWBVZKTFUN6FHJNUI",
              secretAccessKey: "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"
            });
            console.log(
              "lllllllllllllllllllllllllll",
              this.arrayItemprefix.Prefix + files.name
            );
            var params = {
              Bucket: "adjustermate-stage",
              Key:
                this.arrayItemprefix.Prefix + files.name.replace(/\s+/g, "_"),
              Body: Buffer.from(imageUrl, "base64"),
              ContentType: files.type,
              ACL: "public-read-write"
            };
            var self = this;
            s3Client.putObject(params, function(err, dataValue) {
              if (err) {
                console.log(err);
              } else {
                console.log(dataValue);
                self.addResource(arrayItem, "0");
                self.loading2 = false;
                self.addContentStatus = false;
                self.addContentFolder = "";
                this.text = "Added Successfully";
                this.alertPositive = true;
              }
            });
          });
        }
      } else {
        this.text = "Please Enter File Name";
        this.alertNegetive = true;
      }
    },
    // addChild(item) {
    //   if (!item.children) {
    //     this.$set(item, "children", []);
    //   }

    //   const name = `${item.name} (${item.children.length})`;
    //   const id = item.id++;
    //   item.children.push({
    //     id,
    //     name
    //   });
    //   console.log(item);
    // },
    validateFormDetails() {
      // alert(20);
      //console.log(this.arrayOfFolder);
      if (this.arrayOfFolder.length == 0) {
        valid = true;
      } else {
        var valid = false;
        for (let i = 0; i < this.arrayOfFolder.length; i++) {
          if (this.addFolderName == this.arrayOfFolder[i].namefolder) {
            // console.log(this.deployedFormTemepletes[i].form_name);
            valid = false;
            break;
          } else {
            valid = true;
          }
        }
      }
      //  alert(valid);
      return valid;
    },
    addOfFolderMethod(itemsValue) {
      if (
        this.rules.specialCharecter(this.addFolderName) ==
        "Special Characters Not Allowed"
      ) {
        this.text = "Please Enter Proper Folder Name";
        this.alertNegetive = true;
      } else if (this.addFolderName == "") {
        this.text = "Please Enter Proper Folder Name";
        this.alertNegetive = true;
      } else if (this.validateFormDetails() == false) {
        this.text = "Folder Name Already Exist";
        this.alertNegetive = true;
      } else {
        this.loading3 = true;
        var dataWithPrefix = itemsValue;
        var s3Client = new aws.S3({
          region: "us-east-1",
          accessKeyId: "AKIAWBVZKTFUN6FHJNUI",
          secretAccessKey: "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"
        });

        var params = {
          Bucket: "adjustermate-stage",
          Key: itemsValue.Prefix + this.addFolderName + "/",
          // ContentType: contentType,
          Body: null,
          ACL: "public-read-write"
        };

        var self = this;
        s3Client.putObject(params, function(err, data) {
          console.log(data);
          if (err) {
            console.log(err);
          } else {
            self.listCreatedObjects(params, dataWithPrefix);
          }
        });
      }
    },
    listCreatedObjects(bucketJSON, dataPrefix) {
      var dataToSendResource = dataPrefix;
      var s3Client = new aws.S3({
        region: "us-east-1",
        accessKeyId: "AKIAWBVZKTFUN6FHJNUI",
        secretAccessKey: "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"
      });
      let params = {
        Bucket: bucketJSON.Bucket,
        FetchOwner: false,
        EncodingType: "url",
        Prefix: dataPrefix.Prefix
        // Prefix: response.key //"MOBIL80/USER/f931447f-9424-4d5c-a29a-18299b997428/"
      };
      s3Client.listObjectsV2(params, function(err, dataValue) {
        if (err) console.log(err, err.stack);
        // an error occurred
        else {
          console.log(dataValue);
        } // successful response
      });
      this.addResource(dataToSendResource, "0");
      this.addFolderStatus = false;
      this.addFolderName = null;
      this.loading3 = false;
      this.text = "Added Successfully";
      this.alertPositive = true;
    },

    addFolder() {
      this.addFolderStatus = true;
    },
    addcontant() {
      //console.log(this.addFolderStatus);
      this.addContentStatus = true;
      //console.log(this.addFolderStatus);
    },
    treeViewMethod(items) {
      //console.log(items);
      this.nameOfFolder = [];
      this.nameOfFolder = items;
    }
    // upload() {
    //   var s3Client = new aws.S3({
    //     region: "us-east-1",
    //     accessKeyId: "AKIAWBVZKTFUN6FHJNUI",
    //     secretAccessKey: "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"
    //   });
    //   var params = {
    //     Bucket: "adjustermate-prod",
    //     Key: "17/resource/test123/",
    //     Body: null,
    //     // ContentType: contentType,
    //     ACL: "public-read-write"
    //   };
    //   console.log(params);
    //   s3Client.putObject(params, function(err, data) {
    //     console.log(err);
    //     console.log(data);
    //   });
    // }
  }
};
</script>
<style scoped>
#Nobutton {
  margin-left: 30% !important;
}
</style>